import React from 'react'
import { Edit } from 'react-admin'

import SeasonsForm from './form'

export const SeasonsEdit = (props) => (
  <Edit undoable={false} {...props}>
    <SeasonsForm {...props} />
  </Edit>
)

export default SeasonsEdit
